export const hotels = {
  'marriott-merlin': 'https://www.trip.com/t/DwAnN1hzhP2',
  'sunwing-kamala': 'https://www.trip.com/t/DFl7kFS0iP2',
  katathani: 'https://www.trip.com/t/3jitB7U0iP2',
  'ozo-phuket': 'https://www.trip.com/t/Y6Wv5gV0iP2',
  'emerald-karon': 'https://www.trip.com/t/vdshWXX0iP2',
  'angsana-laguna': 'https://www.trip.com/t/O6ySWFZ0iP2',
  'marriott-mai-khao': 'https://www.trip.com/t/O8sYnya0iP2',
  'anantara-vacation-club': 'https://www.trip.com/t/NWVYjWc0iP2',
};
